import Icon from '../components/Icon.vue'

Icon.register({
  synagogue: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M70 196.5c5.3-6 14.7-6 20 0l38 43.1v272.4h-128v-226.1 0c0-5.6 3-13.5 6.7-17.6zM633.3 268.3c4.3 4.9 6.7 11.1 6.7 17.6v226.1h-128v-272.4l38-43.1c5.3-6 14.7-6 20 0zM340 7l128 102.4c7.6 6.1 12 15.3 12 25v377.6h-96v-96c0-38.9-34.7-69.7-74.8-63.1-31.5 5.1-53.3 34.7-53.3 66.5v92.6h-96v-377.6c0-8.5 5.4-19.7 12-25l128-102.4c11.7-9.3 28.3-9.3 40 0zM392.1 222.6l-19.2-30.6 19.2-30.6c2-3.1-0.3-7.2-4-7.2h-39l-25.1-40c-1.8-3-6.2-3-8 0l-25.1 40h-38.9c-3.7 0-6 4.1-4 7.2l19.2 30.6-19.2 30.6c-2 3.1 0.3 7.2 4 7.2h38.9l25.1 40c1.8 3 6.2 3 8 0l25.1-40h38.9c3.7 0 6-4.1 4-7.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/synagogue.js
// module id = 1971
// module chunks = 0